import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import saveAs from 'file-saver';
import { MenuItem, MessageService } from 'primeng/api';
import { first, shareReplay } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CaoService } from 'src/app/services/cao.service';
import { BaseService } from 'src/app/services/common/base.service';
import { TokenService } from 'src/app/services/common/token.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { IpAddressService } from 'src/app/services/ip-address.service';

@Component({
  selector: 'app-subsidy-to-vendor-pfms-esparsh',
  templateUrl: './subsidy-to-vendor-pfms-esparsh.component.html',
  styleUrls: ['./subsidy-to-vendor-pfms-esparsh.component.scss'],
  providers: [DatePipe],
})
export class SubsidyToVendorPfmsEsparshComponent implements OnInit {
  @Input() lotDetails: string;
  @ViewChild('subsidyToVendorPFMSReportTable', { static: true }) public subsidyToVendorPFMSReportTable: any;

  selectedBankAccounts: any[];

  submitted: boolean;
  menuItems: MenuItem[];

  statuses: any[];
  cols: ({ field: string; header: string; customExportHeader: string; } | { field: string; header: string; customExportHeader?: undefined; })[];
  exportColumns: { title: string; dataKey: string; }[];
  subsidyToVendorPFMSReportModel: any[];
  addDialog: boolean;

  lotNo: number;
  public filteredData: any = [];
  selectedStatus: any;
  remarks: String;
  date: any;
  public userID: any;
  miSurveyData: any[];
  items: any[];
  appVerificationItems: MenuItem[];
  public totalSelectedApp: any = 0;
  public totalSubToFarmer: any = 0;
  public totalSubToVendor: any = 0;
  public totalFarmerRefund: any = 0;
  filteredDataForExport: any = [];
  ipAddress: any = '000.000.000';
  public loading: boolean = false;
  public loading1: boolean = false;
  public subscriptions: any = [];

  public subjectSub:any;
  public selectedYear:any;
  public isCAOLogin: boolean = false;
  public printGeneratedDate: any;
  public miCertificateData: any = {};
  public isDuplicateFound: boolean = false;

  constructor(
    private messageService: MessageService, 
    private caoService: CaoService, 
    private router: Router, 
    private tokenService: TokenService, 
    private cryptoJsService: CryptoJsService, 
    private deptDashBoardService: DepartmentDashboardService, 
    private ipService: IpAddressService, 
    private dashboard: DashboardService, 
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private service: BaseService,
    private datePipe: DatePipe,
    ) { }
  
  ngOnInit() {
    this.date = new Date();
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;

    const tokenData = sessionStorage.getItem('token')
      ? JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')))
      : {};
    if(tokenData && (tokenData.role == 'CAO')){
      this.isCAOLogin = true;
    }
    // this.loadData();
    this.loadDataAndApplyFilter();

    this.getIP();
    this.menuItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.exportExcel(this.subsidyToVendorPFMSReportModel, "MI Subsidy To Vendor PFMS Report");
        }
      },
      {
        label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
          this.downloadSheetAsPdf(this.subsidyToVendorPFMSReportModel, "MI Subsidy To Vendor PFMS Report");
        }
      },
    ];

    // let actionId = 28; // Do not Change, it is fixed for Farmer Application Verifications
    // this.deptDashBoardService
    //   .GetStatusMaster(JSON.parse(payload)?.sub, actionId)
    //   .pipe(first())
    //   .subscribe({
    //     next: (data) => {
    //       this.items = data.$values;
    //     },
    //     error: () => {
    //       this.messageService.add({
    //         severity: 'error',
    //         summary: 'Error Message',
    //         detail: 'Status Master cant be Loaded',
    //       });
    //     },
    //   });

    this.appVerificationItems = [
      {
        label: 'Download excel', icon: 'pi pi-fw pi-download', command: () => {
          this.pfmsExportExcel(this.miSurveyData, `${this.lotNo}_(${this.date})`);
        }
      },
      // {
      //   label: 'Download Pdf', icon: 'pi pi-fw pi-download', command: () => {
      //     this.downloadSheetAsPdf(this.filteredDataForExport, `Filtered Lot Data__(${this.date})`);
      //   }
      // },
    ];

  }
 
  
  loadDataAndApplyFilter(){
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }

    if(this.lotDetails){
      this.loadData();
    }else{
      this.subjectSub = this.service.getSelectedYear().pipe(shareReplay()).subscribe(
        (res) => {
          this.loadData();
     
          this.selectedYear = res;
          this.subsidyToVendorPFMSReportTable.filters['FinYear'] = [
            { value: this.selectedYear, matchMode: 'startsWith', operator: 'and' },];
        }
      );
    }
  }
  
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe();
    }
  }
  

  onFiltering(event: any) {
    // console.log('Filtered value: ' + JSON.stringify(event.filters));
  }

  loadData() {
    // this.loader.start();

    this.loading = true;
    let reqBody = {
      UserType: "",
      FinYear: ''
    }
    if(this.lotDetails != undefined){
      reqBody = {
        UserType: '',
        FinYear: this.lotDetails?.['F.Y.']
      }
    }

    
    // let sub=this.caoService.miSubsidyToVendorPFMSReport("Farmer,7500")
    let sub=this.caoService.miSubsidyToVendorPFMSReport(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;
          // console.log("hello##3")
          data = data.map(val => ({ 
            ...val,
            lotNoForSorting: parseInt(val?.Lot_No.slice(7))
          }))
          this.activityRecordService.activityRecord(this.userID, 'Subsidy To Vendor PFMS Report (PDMC)', '', new Date(), 'Success');

          if (data.length > 0) {
            this.subsidyToVendorPFMSReportModel = data;
          }
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          this.activityRecordService.activityRecord(this.userID, 'Subsidy To Vendor PFMS Report (PDMC)', '', new Date(), err);

          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

        }
      });
      this.subscriptions.push(sub);
  }

  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'Srno', header: 'Sr no' },
      { field: 'Lot_No', header: 'File No' },
      { field: 'dateofExport', header: 'Date of Export' },
      { field: 'Total_Sum', header: 'Total Sum' },
      { field: 'Sum_of_PFMS_Export', header: 'Sum of PFMS Export' },

      { field: 'Sum_of_Centre_Share_AllRec', header: 'Sum of Centre Share' },
      { field: 'Sum_of_State_Share_AllRec', header: 'Sum of State Share' },
      { field: 'TopUp_All', header: 'Sum Of Topup All' },

      { field: 'No_of_Successfull_Records', header: 'No of Successfull Records' },
      { field: 'Sum_of_Successfull_Records', header: 'Sum of Successfull Records' },

      { field: 'No_of_Record', header: 'No of Record' },
      { field: 'NoOfPendingRecords', header: 'No of Pending Records' },
      { field: 'No_of_Failed_Records', header: 'No of Failed Records' },

      { field: 'SumOfPendingRecords', header: 'Sum of Pending Records' },
      { field: 'Sum_of_Failed_Records', header: 'Sum of Failed Records' },

      { field: 'NoOfSuccessfullBankRec', header: 'Sum of Bank Transfer Successfull Records' },
          
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));

    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData);
        doc.save(`${filename}.pdf`);
      })
    })
  }


  hideDialog() {
    this.addDialog = false;
    this.miSurveyData = [];
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import("xlsx").then(xlsx => {
      let dataToSave = modelData.map((d: any) => {
        return {
          "Sr no": d.Srno,
          "File No": d.Lot_No,
          "Date of Export": d.dateofExport,
          "No of Record": d.No_of_Record,
          "Total Sum": d.Total_Sum,
          "Sum of PFMS Export": d.Sum_of_PFMS_Export,
          "Sum of Centre Share (All records)": d.Sum_of_Centre_Share_AllRec,
          "Sum of State Share (All records)": d.Sum_of_State_Share_AllRec,
          "Sum of Top Up (All records)": d.TopUp_All,

          // "Sum of Centre Share (Successful records)": d.Sum_of_Centre_Share_SuccessfullRec,
          // "Sum of Centre Share (Pending records)": d.Sum_of_Centre_Share_PenRec,
          // "Sum of Centre Share (Failed records)": d.Sum_of_Centre_Share_FailedRec,
          // "Sum of State Share (Successful records)": d.Sum_of_State_Share_SuccessfullRec,
          // "Sum of State Share (Pending records)": d.Sum_of_State_Share_PenRec,
          // "Sum of State Share (Failed records)": d.Sum_of_State_Share_FailedRec,
          "No of Successfull Records": d.No_of_Successfull_Records,
          "No of Pending Records": d.NoOfPendingRecords,
          "No of Failed Records": d.No_of_Failed_Records,
          
          "Sum of Successfull Records": d.Sum_of_Successfull_Records,
          "Sum of Pending Records": d.SumOfPendingRecords,
          "Sum of Failed Records": d.Sum_of_Failed_Records,
          "Sum of Bank Transfer Successfull Records": d.NoOfSuccessfullBankRec,
        }
      })
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  // handleClick() {
  //   let newFilteredData = this.filteredData.map(row => ({
  //     ...row,
  //     status: this.selectedStatus.flag,
  //     remarks: this.remarks ? this.remarks : 'undefined',
  //   }))

  //   let reqBody = {
  //     listLotData: newFilteredData,
  //     userID: this.userID,
  //     network_Id: this.ipAddress,
  //     terminal_Id: this.ipAddress,
  //     subSidyType: 'FTV',
  //   }
  //   console.log("reqBody", reqBody)

  //   this.insertMISubsidyLot(reqBody);
  // }

  refreshTable(){
    this.loadData();
  }
  
  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    }else{
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress',JSON.stringify(this.ipAddress));
      });
    }
  }

  insertMISubsidyLot(reqBody) {
    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify([reqBody]))
    }

    // this.loader.start();
    this.loading = true;
    this.deptDashBoardService.insertMISubsidyLot(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading = false;
          this.messageService.add({
            severity: 'info',
            summary: 'Status',
            detail: JSON.stringify(data),
          });
          this.pmfsExport(reqBody.Lot_No, '');
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  groupedVendors: any[] = [];
  filteredVendors: any[] = [];
  filterText: string = '';

  pmfsExport(lotId, status) {
    this.printGeneratedDate = this.toISOLocal(new Date()).replace(/.\d+Z$/g, "");
    this.addDialog = true;
    this.lotNo = lotId;
    // this.loader.start();
    this.loading1 = true;
    this.getLotDetails(lotId, status);
    this.getLotCertificateData(lotId, status);
  }

  getLotCertificateData(lotId, status){
    this.miCertificateData = null;
    if(status== ''){
      this.caoService.getDataForLotCertificate_STV(lotId, 'isAtal')
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.miCertificateData = data[0];
          this.activityRecordService.activityRecord(this.userID, 'Farmer Share to Farmer PFMS Export (ABY) Lot Certificate', lotId, new Date(), 'Success');
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
          this.activityRecordService.activityRecord(this.userID, 'Farmer Share to Farmer PFMS Export (ABY) lot Certificate', lotId, new Date(), err);
        }
      });
    }
  }

  getLotDetails(lotId, status){
    this.caoService.miSubsidyToVendorPFMSExport(lotId, status, 'Farmer,7500')
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          this.loading1 = false;
          // console.log("dataaa", data)
          if (data?.length > 0) {
            this.miSurveyData = data;
            const flag = this.hasDuplicate(data);
            if(flag['duplicate'] == true) {
              this.isDuplicateFound = true;
              this.messageService.add({ 
                severity: 'warn', 
                summary: 'Warn Message', 
                detail: `Duplicate values found in the data. Please contact to technical team. Duplicate ${flag['type']} : ${flag['value']}`,
                sticky: true,
                closable: true
              });
            } else {
              this.isDuplicateFound = false;
            }

            this.miSurveyData = this.miSurveyData.map(row => ({
              ...row,
              AppId_ProgID: row.Scheme_Specific_Id.concat("_", row.ProgramID)
            }))

            this.groupVendors();
            this.filteredVendors = [...this.groupedVendors];

            // console.log("RTFdata", this.miSurveyData)
          }
          else{
            this.isDuplicateFound = false;
            this.miSurveyData = [];
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Data Not Available' });
          }
          this.activityRecordService.activityRecord(this.userID, 'Subsidy To Vendor PFMS Export (PDMC)', lotId, new Date(), 'Success');
        },
        error: (err) => {
          this.isDuplicateFound = false;
          this.miSurveyData = [];
          // this.loader.close();
          this.loading1 = false;
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
          this.activityRecordService.activityRecord(this.userID, 'Subsidy To Vendor PFMS Export (PDMC)', lotId, new Date(), err);
        }
      });
  }

  hasDuplicate(records) {
    const appIds = new Set();
    // const aadhars = new Set();

    for (const item of records) {
      if (appIds.has(item.Scheme_Specific_Id)) {
        return { duplicate: true, type: "AppId", value: item.Scheme_Specific_Id };
      }
      // if (aadhars.has(item.Aadhar_No)) {
      //   return { duplicate: true, type: "Aadhar", value: item.Aadhar_No };
      // }

      appIds.add(item.AppId);
      // aadhars.add(item.Aadhar_No);
    }

    return { duplicate: false };
  }


  // Group data by vendor name
  groupVendors(): void {
    const vendorMap = new Map();
    
    this.miSurveyData.forEach(item => {
      const vendorName = item.Full_Name_In_English;
      if (!vendorMap.has(vendorName)) {
        vendorMap.set(vendorName, {
          vendorName: vendorName,
          gstNo: item.GST_NO,
          panNo: item.Vendor_Pan_Card_No,
          caoRemarks: item.CAORemarks,
          items: [],
          beneficiaryCount: 0, // Initialize beneficiary count
        });
      }
      const vendor = vendorMap.get(vendorName);
      vendor.items.push(item);
      vendor.beneficiaryCount = vendor.items.length; // Update beneficiary count
    });

    // If you want total vendor count, you can use:
    const vendorCount = vendorMap.size;
    
    this.groupedVendors = Array.from(vendorMap.values());
    // console.log("Grouped Vendors:", this.groupedVendors);
  }

  // Apply filter based on vendor name
  applyFilter(): void {
    if (!this.filterText) {
      this.filteredVendors = [...this.groupedVendors];
      return;
    }
    
    const filter = this.filterText.toLowerCase();
    this.filteredVendors = this.groupedVendors.filter(vendor => 
      vendor.vendorName.toLowerCase().includes(filter)
    );
  }

  // Get farmer name from the data
  getFarmerName(item: any): string {
    // This is a placeholder - you'll need to adjust based on your actual data structure
    return 'Farmer Name'; // Replace with actual farmer name field
  }

  // Calculate total amount for a row
  calculateTotal(item: any): number {
    return (item.Center_Share_Payment_Amount || 0) + 
           (item.State_Share_Payment_Amount || 0) + 
           (item.TopUp || 0);
  }

  // Vendor totals
  getVendorTotalArea(vendor: any): number {
    return vendor.items.reduce((sum: number, item: any) => sum + (item.MIArea || 0), 0);
  }

  getVendorTotalFarmerShare(vendor: any): number {
    return vendor.items.reduce((sum: number, item: any) => sum + (item.FarmerShareAmt || 0), 0);
  }

  getVendorTotalCenterShare(vendor: any): number {
    return vendor.items.reduce((sum: number, item: any) => sum + (item.Center_Share_Payment_Amount || 0), 0);
  }

  getVendorTotalStateShare(vendor: any): number {
    return vendor.items.reduce((sum: number, item: any) => sum + (item.State_Share_Payment_Amount || 0), 0);
  }

  getVendorTotalTopUp(vendor: any): number {
    return vendor.items.reduce((sum: number, item: any) => sum + (item.TopUp || 0), 0);
  }

  getVendorTotalAmount(vendor: any): number {
    return this.getVendorTotalCenterShare(vendor) + 
           this.getVendorTotalStateShare(vendor) + 
           this.getVendorTotalTopUp(vendor);
  }

  // Grand totals
  getGrandTotalArea(): number {
    return this.filteredVendors.reduce((sum, vendor) => sum + this.getVendorTotalArea(vendor), 0);
  }

  getGrandTotalFarmerShare(): number {
    return this.filteredVendors.reduce((sum, vendor) => sum + this.getVendorTotalFarmerShare(vendor), 0);
  }

  getGrandTotalCenterShare(): number {
    return this.filteredVendors.reduce((sum, vendor) => sum + this.getVendorTotalCenterShare(vendor), 0);
  }

  getGrandTotalStateShare(): number {
    return this.filteredVendors.reduce((sum, vendor) => sum + this.getVendorTotalStateShare(vendor), 0);
  }

  getGrandTotalTopUp(): number {
    return this.filteredVendors.reduce((sum, vendor) => sum + this.getVendorTotalTopUp(vendor), 0);
  }

  getGrandTotalAmount(): number {
    return this.getGrandTotalCenterShare() + 
           this.getGrandTotalStateShare() + 
           this.getGrandTotalTopUp();
  }

  // Grand total of beneficiaries across filtered vendors
  getGrandTotalBeneficiaries(): number {
    return this.filteredVendors.reduce((sum, vendor) => sum + (vendor?.beneficiaryCount || 0), 0);
  }


  // onRowSelect(event) {
  //   // this.calculation();
  //   this.messageService.add({
  //     severity: 'info',
  //     summary: 'Product Selected',
  //     detail: event.data.name,
  //   });
  // }

  // onRowUnselect(event) {
  //   // this.calculation();
  //   this.messageService.add({
  //     severity: 'info',
  //     summary: 'Product Unselected',
  //     detail: event.data.name,
  //   });
  // }

  // calculation() {
  //   this.filteredData = [];
  //   // this.filteredDataForExport = event.filteredValue;
  //   this.totalSelectedApp = 0;
  //   this.totalSubToFarmer = 0;
  //   this.totalSubToVendor = 0;
  //   this.totalFarmerRefund = 0;

  //   this.totalSelectedApp = this.filteredDataForExport.length;
  //   this.filteredDataForExport.forEach((val) => {
  //     this.totalSubToFarmer += val.SubsidyToFarmer_Amount;
  //     this.totalSubToVendor += val.SubsidyToVendor_Amount;
  //     this.totalFarmerRefund += val.FarmerRefund_Amount;
  //   })
  //   this.filteredDataForExport.forEach(val => {
  //     this.filteredData.push(
  //       {
  //         appID: val.Scheme_Specific_Id,
  //         programID: val.ProgramID,
  //         subsidy_Amt: 0,
  //         amt_Disbus_to_Vendor: 0,
  //         amt_Refund_to_Farmer: 0,
  //         subsidyToVendor: val.Farmer_Share_To_Vendor,
  //         state_share_amt: val.State_Share_Payment_Amount,
  //         centre_share_amt: val.Center_Share_Payment_Amount,
  //       })
  //   })
  // }

  selectFarmerApplication(application) {
    if(application.Scheme_Specific_Id){
      // this.loader.start();
    this.loading = true;
      this.dashboard
      .getMIDetailByAppID(application.Scheme_Specific_Id)
      .pipe(first())
      .subscribe({
        next: (res) => {
          // this.loader.close();
          this.loading = false;
          const link = this.router.serializeUrl(
            this.router.createUrlTree([
              this.router.url.split('/')[1],
              'print',
            ],  { queryParams: { appId:this.cryptoJsService.Encrypt(application.Scheme_Specific_Id.toString()) } }));
          // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(application.Scheme_Specific_Id), ,res[0]?.VendorId,res[0]?.ProgId,res[0]?.User_ID,res[0]?.AutoId]));
          window.open(link, '_blank');
        },
        error: (err) => {
          // this.loader.close();
          this.loading = false;
          // console.log("error", err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
    }
     else {
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Invalid App ID' });
    }
  }

  pfmsExportExcel(modelData, filename) {
    this.countNoOfTimesExported();
    import("xlsx").then(xlsx => {
      // Sheet 1: Vendor Data
      let sheetData = [];
      const itemHeaders = [
        'Sr. No.',
        'Lot No.',
        'Application No.',
        'Farmer Name',
        'Farmer Type',
        'Village',
        'Block',
        'District',
        'Caste Description',
        'MI Type',
        'MI Area',
        'Farmer Share',
        'Credited Date',
        'Center Share Payment',
        'State Share Payment',
        'Top Up',
        'Total Amount',
      ];

      let vendors = this.filteredVendors && this.filteredVendors.length ? this.filteredVendors : this.groupedVendors;
      vendors.forEach((vendor, idx) => {
        // push a bold-unicode version of the vendor line so it appears bold in Excel
        const toBoldUnicode = (s: string) =>
          s.replace(/[A-Za-z0-9]/g, (c) => {
            const code = c.charCodeAt(0);
            if (c >= 'A' && c <= 'Z') return String.fromCodePoint(0x1D400 + (code - 65));
            if (c >= 'a' && c <= 'z') return String.fromCodePoint(0x1D41A + (code - 97));
            if (c >= '0' && c <= '9') return String.fromCodePoint(0x1D7CE + (code - 48));
            return c;
          });

        sheetData.push({
          'Sr. No.': toBoldUnicode(`Vendor: ${vendor.vendorName}, GST No: ${vendor.gstNo}, PAN No: ${vendor.panNo}`),
        });
        let headerRow = {};
        itemHeaders.forEach(h => headerRow[h] = h);
        sheetData.push(headerRow);
        vendor.items.forEach(item => {
            sheetData.push({
            'Sr. No.': vendor.items.indexOf(item) + 1,
            'Lot No.': this.lotNo,
            'Application No.': item.Scheme_Specific_Id,
            'Farmer Name': item.farmerName,
            'Farmer Type': item.FarmerType,
            'Village': item.Village,
            'Block': item.Block,
            'District': item.District,
            'Caste Description': item.Caste_Description,
            'MI Type': item.Programme_Name,
            'MI Area': item?.MIArea,
            'Farmer Share': item?.FarmerShareAmt,
            'Credited Date': item?.CreditedOnDateTime ? item?.CreditedOnDateTime : '',
            'Center Share Payment': item.Center_Share_Payment_Amount,
            'State Share Payment': item.State_Share_Payment_Amount,
            'Top Up': item.TopUp,
            'Total Amount': this.calculateTotal(item),
            });
        });
        sheetData.push({
          'Application No.': 'Vendor Totals',
          'MI Area': this.getVendorTotalArea(vendor),
          'Farmer Share': this.getVendorTotalFarmerShare(vendor),
          // 'Beneficiary (No.)': vendor.beneficiaryCount,
          'Center Share Payment': this.getVendorTotalCenterShare(vendor),
          'State Share Payment': this.getVendorTotalStateShare(vendor),
          'Top Up': this.getVendorTotalTopUp(vendor),
          'Total Amount': this.getVendorTotalAmount(vendor),
        });
        sheetData.push({});
      });
      // sheetData.push({
      //   'Application No': 'Grand Totals',
      //   'MI Area': this.getGrandTotalArea(),
      //   'Farmer Share': this.getGrandTotalFarmerShare(),
      //   'Beneficiary (No.)': this.getGrandTotalBeneficiaries(),
      //   'Center Share Payment Amount': this.getGrandTotalCenterShare(),
      //   'State Share Payment Amount': this.getGrandTotalStateShare(),
      //   'Top Up': this.getGrandTotalTopUp(),
      //   'Total Amount': this.getGrandTotalAmount(),
      // });

      // Add a blank row then vendor table as objects mapped to the existing itemHeaders
      sheetData.push([]);

      // Vendor Table Header (mapped to the same columns used in the sheet so the row appears from column A)
      sheetData.push({
        // 'Application No.': '',
        // 'Lot No.': '',
        // 'Farmer Name': '',
        'Farmer Type': this.miCertificateData?.Program_Name,
        // 'Application Type': '',
        // 'Caste Description': '',
      });

      sheetData.push({
        'Lot No.': 'Sr. No.',
        'Application No.': 'Vendor Name',
        'Farmer Name': 'Beneficiary (No.)',
        'Farmer Type': 'Center Share Payment Amount',
        'Village': 'State Mandetory Share Payment Amount',
        'Block': 'Top Up',
        'District': 'Total Amount'
      });

      // Vendor Table Body (each row mapped to the same first columns so data starts from the left)
      (this.groupedVendors || []).forEach((item, idx) => {
        sheetData.push({
          'Lot No.': idx + 1,
          'Application No.': item.vendorName,
          'Farmer Name': item.beneficiaryCount,
          'Farmer Type': this.getVendorTotalCenterShare(item),
          'Village': this.getVendorTotalStateShare(item),
          'Block': this.getVendorTotalTopUp(item),
          'District': this.getVendorTotalAmount(item)
        });
      });

      sheetData.push({
        'Lot No.': 'Total',
        'Application No.': '',
        'Farmer Name': this.getGrandTotalBeneficiaries(),
        'Farmer Type': this.getGrandTotalCenterShare(),
        'Village': this.getGrandTotalStateShare(),
        'Block': this.getGrandTotalTopUp(),
        'District': this.getGrandTotalAmount()
      });

      sheetData.push({ 'Sr. No.': `` });
      sheetData.push({ 'Sr. No.': `It is certified that : -` });
      sheetData.push({ 'Sr. No.': `1. The terms and conditions on the basis of which subsidy has proposed to be released have been fulfilled as per operational guidelines of PDMC scheme.` });
      sheetData.push({ 'Sr. No.': `2. MI system installed is as per approved specification based on area specified by Farmers in their application and within approved cost/ estimate.` });
      sheetData.push({ 'Sr. No.': `3. The benefit of scheme has extended to intended beneficiaries only one time and no payment were made earlier against these proposed application either to farmer or vendor.` });
      sheetData.push({ 'Sr. No.': `4. The cases are submitted for first time for release of assistance.` });
      sheetData.push({ 'Sr. No.': `5. The Farmer had deposited its 15% contribution as farmer share.` });
      sheetData.push({ 'Sr. No.': `6. All required documents from both the vendors and beneficiary have been verified and uploaded on MI Portal.` });
         

      const worksheet1 = xlsx.utils.json_to_sheet(sheetData, { skipHeader: true });

      // Sheet 2: Certificate/Sanction Letter
      let certData = [];
      // Header
      certData.push([``, ``, ``, `SANCTION LETTER`]);
      certData.push([``, ``, ``, `HARYANA`]);
      certData.push([``, ``, ``, `Financial Year: ${this.selectedYear || ''}`]);
      certData.push([]);
      certData.push([`Lot No. : ${this.lotNo}`, ``, ``, ``, ``, ``, `Date of Print Generated ${this.printGeneratedDate}` ]);
      certData.push([]);
      certData.push([``, ``, ``, `ORDER`]);
      certData.push([`Sanction is hereby accorded for disbursement of subsidy of Rs. ${ this.getGrandTotalAmount() || ''} on a/c of installation of Micro Irrigation System ${this.miCertificateData?.Program_Name || ''}`]);
      certData.push([`by the applicant farmer on farmer share basis to the registered vendors through E-Sparsh portal as per GOI instructions from Centrally sponsored scheme code ${this.miCertificateData?.CenterSponsoredScheme || ''}`]);
      certData.push([`and & State linked scheme code ${this.miCertificateData?.StateSponsoredScheme || ''}.`]);
      certData.push([]);
      certData.push([`Administrator MICADA been the competent authority had sanctioned the expenditure as per details under:`]);
      certData.push([]);
      // Vendor Table Header
      certData.push([`Sn.`, `Name of Payee`, `Particular`, `Lot No.`, `E-office No. & Dated`, `Beneficiary (No.)`, `Total`]);
      // Vendor Table Body
      (this.groupedVendors || []).forEach((item, idx) => {
        certData.push([
          idx + 1,
          item.vendorName,
          'Disbursement of Subsidy',
          this.lotNo,
          item.caoRemarks,
          item.beneficiaryCount,
          this.getVendorTotalAmount(item)
        ]);
      });
      // Vendor Table Footer - beneficiary total + amount
      certData.push([`Total`, '', '', '', '', this.getGrandTotalBeneficiaries(), this.getGrandTotalAmount()]);
      certData.push([]);
      certData.push([`The expenditure will be met out for the budget the head for F.Y. ${this.miCertificateData?.financialYear || ''}.`]);
      certData.push([`Implementation of Pradhan Mantri Krishi Sinchayee Yojana- Per Drop More Crop ${this.miCertificateData?.caste || ''} Under Head ${this.miCertificateData?.code || ''}.`]);
      certData.push([]);
      certData.push([]);
      certData.push([]);
      certData.push([``, ``, ``, ``, ``, ``, ``, `Engineer-in-Chief`]);
      certData.push([``, ``, ``, ``, ``, ``, ``, `Irrigation & W.R. Deptt.`]);
      certData.push([``, ``, ``, ``, ``, ``, ``, `Cum-Administrator, MICADA`]);
      certData.push([``, ``, ``, ``, ``, ``, ``, `Haryana (SNA-SPARSH)`]);
      certData.push([]);
      certData.push([`Endst. No./MICADA/ ${this.miCertificateData?.eNo || ''}`, ``, ``, ``, ``, ``, `Dated: ${this.miCertificateData?.date || ''}`]);
      certData.push([]);
      certData.push([`A copy is forwarded to the following for information and n/a please:`]);
      certData.push([`1. The Principal Accountant General (A&E), Haryana, Chandigarh.`]);
      certData.push([`2. Treasury Officer, Cyber Treasury, Panchkula.`]);
      certData.push([`3. Chief Accounts Officer, MICADA for making payment through E-Sparsh Portal. (Two copies)`]);
      certData.push([`4. Xen (Drainage) H.Q. Panchkula of Irrigation & Water Resources Dept. (SNA- Sparsh) being DDO (PDMC- PMKSY).`]);
      certData.push([]);
      certData.push([]);
      certData.push([]);
      certData.push([``, ``, ``, ``, ``, ``, ``,``, `Director (MI)`]);
      certData.push([``, ``, ``, ``, ``, ``, ``,``, `For Administrator`]);
      certData.push([``, ``, ``, ``, ``, ``, ``,``, `MICADA, Panchkula`]);

      const worksheet2 = xlsx.utils.aoa_to_sheet(certData);

      // Create workbook with two sheets
      const workbook = { Sheets: { 'Vendor Data': worksheet1, 'Sanction Certificate': worksheet2 }, SheetNames: ['Vendor Data', 'Sanction Certificate'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }

  countNoOfTimesExported(){
    let reqBody = {
      lotType: 'STV',
      subLotType: '',
      lotNo: this.lotNo,
      userId: this.userID,
      network_Id: this.ipAddress,
      terminal_Id: this.ipAddress 
    }

    this.postCountExportDataFrequency(reqBody);
  }

  postCountExportDataFrequency(reqBody) {
    // this.loader.start();
    // this.loading = true;
    this.deptDashBoardService
      .postCountExportDataFrequency(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.loader.close();
          // this.loading = false;
          if(data.Result == 'Success'){
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: data.Result,
            });
          }else {
            this.messageService.add({
              severity: 'info',
              summary: 'Status',
              detail: data.Result,
            });
          }
          
          this.loadData();
        },
        error: (err) => {
          // this.loader.close();
          // this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  rowBackgroundColor(row) {
    if (row.PendingCompletedDays <= -3) {
      //red
      return '#ff8080';
    }else if (row.PendingCompletedDays == -1 || row.PendingCompletedDays == -2) {
      //orange
      return '#ffc966';
    }else if (row.PendingCompletedDays == 0) {
      //light green
      return '#99e699'
    }else return '#ffffff'; 
  }

  toISOLocal(d) {
    var z = n => ('0' + n).slice(-2);
    var off = d.getTimezoneOffset();
    off = Math.abs(off);

    return z(d.getDate()) + '/'
      + z(d.getMonth() + 1) + '/' +
      d.getFullYear();
  }
}
